import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import PaypalAccountList from "./PaypalAccountList";
import PaypalAccountForm from "./PaypalAccountForm";

const PaypalAccountsBlock = ({ onAccountsChange }) => {
  const [accountList, setAccountList] = useState([]);
  const [updatingAccount, setUpdatingAccount] = useState({});
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (typeof onAccountsChange === "function") {
      onAccountsChange(accountList);
    }
  }, [accountList, onAccountsChange]);

  // Tự mở modal khi user click "Sửa" trên list (set updatingAccount có _id).
  useEffect(() => {
    if (updatingAccount && updatingAccount._id) {
      setShowForm(true);
    }
  }, [updatingAccount]);

  const handleOpenCreate = () => {
    setUpdatingAccount({});
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setUpdatingAccount({});
  };

  const isUpdating = !!updatingAccount?._id;

  return (
    <>
      <div className="my-3 p-3 bg-body rounded shadow-sm feature-box">
        <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-0">
          <h6 className="heading mb-0">Tài khoản PayPal</h6>
          <Button size="sm" variant="primary" onClick={handleOpenCreate}>
            <FontAwesomeIcon icon={faPlus} className="me-1" />
            Thêm tài khoản
          </Button>
        </div>
        <PaypalAccountList
          accountList={accountList}
          setAccountList={setAccountList}
          updatingAccount={updatingAccount}
          setUpdatingAccount={setUpdatingAccount}
        />
      </div>

      <Modal
        show={showForm}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isUpdating ? "Cập nhật tài khoản PayPal" : "Kết nối tài khoản PayPal"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaypalAccountForm
            setAccountList={setAccountList}
            updatingAccount={updatingAccount}
            setUpdatingAccount={setUpdatingAccount}
            onSuccess={handleClose}
            onCancel={handleClose}
            embedded
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PaypalAccountsBlock;
